import { render, staticRenderFns } from "./pencatatan_sipil.vue?vue&type=template&id=6be49566&"
import script from "./pencatatan_sipil.vue?vue&type=script&lang=js&"
export * from "./pencatatan_sipil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports